<template>
  <div class="obs_container obs_experience">
    <h1 style="margin-top: 45px;" class="obs_heading typo-h1 text-light-high text-center">{{ $t("onboardingStep.subscribeToNewsletter.title") }}</h1>
    <div class="obs_body">
      <div class="col-5 col-sm-8 mx-auto">
        <div class="obs_body-describes mw-475 row" style="margin-bottom:11px">
          <div class="col-12">
            <router-link :to="{ name: 'LandingPagesTemplate', query: { create: true, 'template-name': $t('onboardingStep.subscribeToNewsletter.defaultPageName'), 'obs':'create-new' } }" class="obs_icon-item">
              <div class="--left_icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7666 1.00002H5C3.89543 1.00002 3 1.89545 3 3.00002V21C3 22.1046 3.89543 23 5 23H19C20.1046 23 21 22.1046 21 21V5.87257C21 5.30111 20.7555 4.75694 20.3283 4.37739L17.0949 1.50484C16.7289 1.17964 16.2562 1.00002 15.7666 1.00002ZM4.99997 17V3.00002H14V8.05006C14 8.60234 14.4477 9.05006 15 9.05006H17.487C18.0393 9.05006 18.487 8.60234 18.487 8.05006C18.487 7.49777 18.0393 7.05006 17.487 7.05006H16V3.20737L19 5.87258V17H4.99997ZM4.99997 19V21H19V19H4.99997Z" fill="currentColor" />
                </svg>
              </div>
              <div class="--text">{{ $t("onboardingStep.subscribeToNewsletter.option1") }}</div>
              <div class="--right_icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 12C17.25 11.5858 16.9142 11.25 16.5 11.25H0.75C0.335787 11.25 0 11.5858 0 12C0 12.4142 0.335787 12.75 0.75 12.75H16.5C16.9142 12.75 17.25 12.4142 17.25 12Z" fill="currentColor" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2197 7.72358C11.9268 8.01647 11.9268 8.49134 12.2197 8.78424L15.4393 12.0039L12.2197 15.2236C11.9268 15.5165 11.9268 15.9913 12.2197 16.2842C12.5126 16.5771 12.9874 16.5771 13.2803 16.2842L17.0303 12.5342C17.3232 12.2413 17.3232 11.7665 17.0303 11.4736L13.2803 7.72358C12.9874 7.43068 12.5126 7.43068 12.2197 7.72358Z" fill="currentColor" />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </router-link>
          </div>
          <div class="col-12 mt-2">
            <router-link class="obs_icon-item" :to="{ name: 'Templates', query: {'obs':'visit-library'} }">
              <div class="--left_icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.8331 4.00644V9.25544H9.08293V4.00644H3.8331ZM3.0291 2.00244C2.36636 2.00244 1.8291 2.5397 1.8291 3.20244V10.0594C1.8291 10.7222 2.36636 11.2594 3.0291 11.2594H9.88693C10.5497 11.2594 11.0869 10.7222 11.0869 10.0594V3.20244C11.0869 2.5397 10.5497 2.00244 9.88693 2.00244H3.0291Z" fill="currentColor" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.8331 14.7442V19.9932H9.08293V14.7442H3.8331ZM3.0291 12.7402C2.36636 12.7402 1.8291 13.2775 1.8291 13.9402V20.7972C1.8291 21.46 2.36636 21.9972 3.0291 21.9972H9.88693C10.5497 21.9972 11.0869 21.46 11.0869 20.7972V13.9402C11.0869 13.2775 10.5497 12.7402 9.88693 12.7402H3.0291Z" fill="currentColor" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9171 4.00644V9.25544H20.1669V4.00644H14.9171ZM14.1131 2.00244C13.4503 2.00244 12.9131 2.5397 12.9131 3.20244V10.0594C12.9131 10.7222 13.4503 11.2594 14.1131 11.2594H20.9709C21.6337 11.2594 22.1709 10.7222 22.1709 10.0594V3.20244C22.1709 2.5397 21.6337 2.00244 20.9709 2.00244H14.1131Z" fill="currentColor" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9171 14.7442V19.9932H20.1669V14.7442H14.9171ZM14.1131 12.7402C13.4503 12.7402 12.9131 13.2775 12.9131 13.9402V20.7972C12.9131 21.46 13.4503 21.9972 14.1131 21.9972H20.9709C21.6337 21.9972 22.1709 21.46 22.1709 20.7972V13.9402C22.1709 13.2775 21.6337 12.7402 20.9709 12.7402H14.1131Z" fill="currentColor" />
                </svg>
              </div>
              <div class="--text">{{ $t("onboardingStep.subscribeToNewsletter.option2") }}</div>
              <div class="--right_icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 12C17.25 11.5858 16.9142 11.25 16.5 11.25H0.75C0.335787 11.25 0 11.5858 0 12C0 12.4142 0.335787 12.75 0.75 12.75H16.5C16.9142 12.75 17.25 12.4142 17.25 12Z" fill="currentColor" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2197 7.72358C11.9268 8.01647 11.9268 8.49134 12.2197 8.78424L15.4393 12.0039L12.2197 15.2236C11.9268 15.5165 11.9268 15.9913 12.2197 16.2842C12.5126 16.5771 12.9874 16.5771 13.2803 16.2842L17.0303 12.5342C17.3232 12.2413 17.3232 11.7665 17.0303 11.4736L13.2803 7.72358C12.9874 7.43068 12.5126 7.43068 12.2197 7.72358Z" fill="currentColor" />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </router-link>
          </div>
          <div class="col-12 mt-2">
            <router-link class="obs_icon-item" :to="{ name: 'Tutorials', query: {'obs':'watch-tutorials'} }" style="margin-top: -1px">
              <div class="--left_icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M23.001 19.0005L23.001 8.23389C23.001 7.74425 22.8214 7.27162 22.4962 6.90557L19.6236 3.67217C19.2441 3.24495 18.6999 3.00049 18.1284 3.00049L3.00098 3.00049C1.89641 3.00049 1.00098 3.89592 1.00098 5.00049L1.00098 19.0005C1.00098 20.1051 1.89641 21.0005 3.00097 21.0005L21.001 21.0005C22.1055 21.0005 23.001 20.1051 23.001 19.0005ZM21.001 19.0005L3.00101 19.0005L3.00101 5.00048L18.1285 5.00048L21.001 8.23388L21.001 19.0005ZM16.1374 12.5937C16.4023 12.4153 16.5611 12.1169 16.5611 11.7975C16.5611 11.4781 16.4023 11.1797 16.1374 11.0013L10.7374 7.36398C10.4431 7.16573 10.0634 7.14601 9.75014 7.31271C9.43686 7.47941 9.2411 7.80533 9.2411 8.1602L9.2411 15.4348C9.2411 15.7897 9.43686 16.1156 9.75014 16.2823C10.0634 16.449 10.4431 16.4293 10.7374 16.231L16.1374 12.5937ZM11.1611 13.6307L11.1611 9.9643L13.8827 11.7975L11.1611 13.6307Z" fill="currentColor" />
                </svg>
              </div>
              <div class="--text">{{ $t("onboardingStep.subscribeToNewsletter.option3") }}</div>
              <div class="--right_icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 12C17.25 11.5858 16.9142 11.25 16.5 11.25H0.75C0.335787 11.25 0 11.5858 0 12C0 12.4142 0.335787 12.75 0.75 12.75H16.5C16.9142 12.75 17.25 12.4142 17.25 12Z" fill="currentColor" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2197 7.72358C11.9268 8.01647 11.9268 8.49134 12.2197 8.78424L15.4393 12.0039L12.2197 15.2236C11.9268 15.5165 11.9268 15.9913 12.2197 16.2842C12.5126 16.5771 12.9874 16.5771 13.2803 16.2842L17.0303 12.5342C17.3232 12.2413 17.3232 11.7665 17.0303 11.4736L13.2803 7.72358C12.9874 7.43068 12.5126 7.43068 12.2197 7.72358Z" fill="currentColor" />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </router-link>
          </div>
          <div class="col-12 mt-4">
            <router-link :to="{ name: 'Dashboard', query: {'obs':'goto-dashboard'} }" class="goback_link typo-paragraph14 text-center">{{ $t("onboardingStep.subscribeToNewsletter.goback") }}</router-link>
          </div>
        </div>
        <div class="subcribe_newsletter">
          <GpCheckbox @change ="subcribedChange" size="small" :label="$t('onboardingStep.subscribeToNewsletter.checkbox')" :value="$t('onboardingStep.subscribeToNewsletter.checkbox')" v-model="isSubscribed" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GpCheckbox } from "@/core/shared/GpForms";
import { mapMutations, mapState } from "vuex";
import { mutations } from "@/store/onboarding/types.js";
import { mutations as accountMutations } from "@/store/account/types.js";

export default {
  name: "LetGetStarted",
  components: {
    GpCheckbox
  },
  props: {
    userName: String
  },
  data() {
    return {
      isSubscribed: false,
      startTime: Date,
      endTime: Date
    };
  },
  computed: {
    ...mapState("onboarding", {
      obsSubscribe: state => state.isSubscribe,
      state: state => state
    })
  },
  created() {
    this.startTime = new Date().getTime();
    this.isSubscribed = this.obsSubscribe.data;
  },
  methods: {
    ...mapMutations("onboarding", {
      obsSubcribe: mutations.OBS_SUBSCRIBE
    }),
    ...mapMutations("account", {
      updateStateObs: accountMutations.ACCOUNT_UPDATE_STATE_OBS
    }),
    subcribedChange() {
      this.submitForm();
    },
    submitForm() {
      this.endTime = new Date().getTime();
      const timeCounter = this.endTime - this.startTime;
      const storeData = {
        data: this.isSubscribed,
        time: timeCounter
      };
      this.obsSubcribe(storeData);
      this.$emit("data");
    }
  }
};
</script>

<style lang="scss" scoped>
.obs_experience {
  width: 100%;
  height: 100%;
}
::v-deep.subcribe_newsletter {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  width:100%;
  .gp-checkbox-text {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: $textLightModeLow;
  }
}
</style>
